// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_fv-2";
export var aiChatCartContainerExit = "_fv-4";
export var aiChatContainerLarge = "_fv-0";
export var aiChatContainerSmall = "_fv-1";
export var aiChatIcon = "_fv-6";
export var slideInFromRight = "_fv-3";
export var slideOutToRight = "_fv-5";